
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/education",
      function () {
        return require("private-next-pages/products/education/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/education"])
      });
    }
  